import { Menu, Drawer } from "antd";
import { ReactComponent as Burger } from "../../../../../images/icons/charm_menu-hamburger.svg";
import React, { useState } from "react";
import NavLinkWithLocation from "../NavLinkWithLocation";
import LanguageSelector from "../../../../i18n/LanguageSelector";
import { CloseOutlined } from "@ant-design/icons";
import "./MenuComponent.css";
import {AmplitudeEvent, logEvent} from "../../../../utils/amplitude";

const MenuComponent = () => {
  const [open, setOpen] = useState(false);

  const showHideDrawer = () => {
    setOpen(!open);
  };

  const onClose = () => {
    setOpen(false);
  };

  const navLinks = [
    { to: "/", textPath: "title.home" },
    { to: "/games", textPath: "title.games" },
  ];

  const menuIcon = open ? <CloseOutlined style={{fontSize: 28}} /> : <Burger />;

  const menuNavLinkClick = (to:string) => () => {
    logEvent(AmplitudeEvent.NAVIGATION_CLICK, {type: "mobile", to});
  };

  return (
    <>
      <button className="mobile" onClick={showHideDrawer}>
          {menuIcon}
      </button>
      <Drawer
        placement="top"
        closable={false}
        onClose={onClose}
        open={open}
        rootClassName="mobile-menu"
      >
        <Menu mode="inline">
          {navLinks.map(({ to, textPath }) => (
            <Menu.Item className="p-[29px]" key={to} onClick={onClose}>
              <NavLinkWithLocation to={to} textPath={textPath} onClick={menuNavLinkClick(to)} />
            </Menu.Item>
          ))}
        </Menu>

        <div className="pl-[27px] pt-[50px]">
          <LanguageSelector />
        </div>
      </Drawer>
    </>
  );
};

export default MenuComponent;
